import { omit } from 'lodash-es'

import { DSR_API_METHOD_TYPES, type DsrEnv } from '@lib/sdk/api/modules/dsr/types.dsr'
import { usePostRobot } from '@lib/sdk/utils/postrobot'

/**
 * Fetches the necessary info for the app to know where it is embedded.
 *
 * Check out [usePitcherApi().getEnv()](../internal/functions/createHighLevelApi.md#getenv) for more information.
 *
 * @example
 * useDsr().getEnv()
 */
export async function getEnv(): Promise<DsrEnv> {
  const pr = await usePostRobot()
  const response = await pr.send(window.parent, DSR_API_METHOD_TYPES.GET_ENV)
  const env = <DsrEnv>response.data
  return omit(env, 'pitcher.org_config.segment')
}
